/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-23 16:07:05
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-11 15:30:06
 * @FilePath: /src/app/payment/components/Address/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

'use client';

import { fetchAddAddress, fetchCustomerAddress, fetchUpdateAddress } from '@/api/account';
import { Address } from '@/api/types/public';
import AddressForm from '@/components/Address';
import Image from '@/components/Image';
import MobileNav from '@/components/MobileNav';
import Popup from '@/components/Popup';
import { useStore } from '@/providers/app-store-provider';
import { RightArrowOutlined } from '@zeelool/icon';
import { useEffect, useImperativeHandle, useState } from 'react';
import AddressPreview from './components/AddressPreview';

import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import { getAddressRules } from '@/utils/form-rule';
import { usePaymentStore } from '../../store';
import ChooseAddress from './components/ChooseAddress';
import { useTranslations } from 'next-intl';

export enum AddressActionType {
  ADD = 'ADD', // 新增模式
  EDIT = 'EDIT', // 编辑模式
  DEFAULT = 'DEFAULT', // 默认模式
}

export default function AddressComponent({
  onAddressChange,
  onEditOrAdd,
  isMobile,
  ref,
  entrancePaymentScene,
  paymentUuid,
  refer_page_name,
  refer_url_path,
}: {
  onAddressChange: (address: Address) => void;
  onEditOrAdd: (val: boolean) => void;
  isMobile?: boolean;
  ref: React.RefObject<any>;
  entrancePaymentScene?: string;
  paymentUuid: string;
  refer_page_name: string;
  refer_url_path: string;
}) {
  const t = useTranslations('payment.address');
  useImperativeHandle(ref, () => ({
    actionType,
    checkValid,
  }));

  const { trackEvent } = useReporting();

  const [valid, setValid] = useState(true);
  const checkValid = () => {
    setValid(false);
  };

  const addressList = usePaymentStore((state) => state.addressList);
  const setAddressList = usePaymentStore((state) => state.setAddressList);

  const countryList = useStore((state) => state.countryList);

  const [actionType, setActionType] = useState(AddressActionType.DEFAULT);

  // 传递给AddressForm的地址数据
  const [addressFormData, setAddressFormData] = useState<Address | null>({
    firstname: '',
    lastname: '',
    country_id: env.NEXT_PUBLIC_ADDRESS_COUNTRY_ID,
    country: env.NEXT_PUBLIC_ADDRESS_COUNTRY,
    street: '',
    apartment: '',
    city: '',
    province: '',
    province_id: '',
    region_code: '',
    postcode: '',
    tel_code: '1',
    tel_country: env.NEXT_PUBLIC_ADDRESS_TEL_COUNTRY,
    telephone: '',
    cpf: '', // 巴西税号
    default: addressList.length > 0 ? 2 : 1,
  });

  const [hasData, setHasData] = useState(true);
  const [loading, setLoading] = useState(false);

  const [showCancel, setShowCancel] = useState(true);

  const [currentAddress, setCurrentAddress] = useState<Address | null>(null);

  const [openAddNewAddress, setOpenAddNewAddress] = useState(false);

  const [chooseAddressShow, setChooseAddressShow] = useState(false);

  // 获取默认地址. result 地址列表通过参数传递进来，应对React的异步机制
  const getDefaultAddress = (id?: number, result?: Address[]) => {
    const _addressList = result || addressList;
    if (id) {
      const defaultAddress = _addressList.find((item) => item.id === id);
      if (defaultAddress) {
        setCurrentAddress(defaultAddress);
      }
      return;
    }
    const defaultAddress = _addressList.find((item) => item.default === 1);
    if (defaultAddress) {
      setCurrentAddress(defaultAddress);
    } else if (_addressList.length > 0) {
      setCurrentAddress(_addressList[0]);
    } else {
      setCurrentAddress(null);
    }
  };

  useEffect(() => {
    if (!entrancePaymentScene) return;
    if (addressList.length > 0) {
      getDefaultAddress();
      SDPlaceOrderPageAddressResult(true);
    } else {
      SDPlaceOrderPageAddressResult(false);
      setHasData(false);
      addNewAddress();
    }
  }, [entrancePaymentScene]);

  // 地址更新时，同步当前地址内容
  useEffect(() => {
    if (addressList.length && currentAddress?.id) {
      const newCurrentAddress = addressList.find((item) => item.id === currentAddress.id);
      if (newCurrentAddress) {
        setCurrentAddress(newCurrentAddress);
      } else {
        // 兜底逻辑，用于多端操作删除地址的情况
        getDefaultAddress();
      }
    }
  }, [addressList]);

  const addNewAddress = () => {
    setActionType(AddressActionType.ADD);
    setAddressFormData({
      firstname: '',
      lastname: '',
      country_id: env.NEXT_PUBLIC_ADDRESS_COUNTRY_ID,
      country: env.NEXT_PUBLIC_ADDRESS_COUNTRY,
      street: '',
      apartment: '',
      city: '',
      province: '',
      province_id: '',
      region_code: '',
      postcode: '',
      tel_code: env.NEXT_PUBLIC_ADDRESS_TEL_CODE,
      tel_country: env.NEXT_PUBLIC_ADDRESS_TEL_COUNTRY,
      telephone: '',
      cpf: '', // 巴西税号
      default: addressList.length > 0 ? 2 : 1,
    });
    setShowCancel(addressList.length > 0);
    onEditOrAdd(true);
  };

  const editAddress = (item: Address) => {
    // 先设置表单数据
    setAddressFormData({
      ...item,
    });

    setShowCancel(true);
    onEditOrAdd(true);
    setActionType(AddressActionType.EDIT);

    SDMyAddressPageBtnClick('Edit');
  };

  const onChooseAddress = (item: Address) => {
    setCurrentAddress(item);
  };

  const handleCancel = () => {
    // TODO:影响到物流方式的显隐
    setActionType(AddressActionType.DEFAULT);
    SDAddressEditPageBtnClick('Cancel', false);
    onEditOrAdd(false);
  };

  const handleOnSubmit = async (item: Address) => {
    // 识别是新增还是修改
    setLoading(true);
    try {
      let handleId = 0;
      if (actionType === AddressActionType.ADD) {
        // 新增
        // 这里的toast隐藏掉，因为它的弹出和全局的loading重复了
        const { code, data } = await fetchAddAddress(item, false);
        if (code !== 200) {
          return;
        }
        handleId = data?.id || 0;
      } else {
        // 修改
        // 这里的toast隐藏掉，因为它的弹出和全局的loading重复了
        const { code } = await fetchUpdateAddress(item.id, item, false);
        if (code !== 200) {
          return;
        }
        handleId = item.id;
      }

      // 不能将当前地址设置为item ，需要重新请求地址列表
      setOpenAddNewAddress(false);
      onEditOrAdd(false);
      SDAddressEditPageBtnClick('Save', true);
      setActionType(AddressActionType.DEFAULT);

      await handleUpdateAddressList(handleId);
    } catch {
      SDAddressEditPageBtnClick('Save', false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentAddress) {
      onAddressChange(currentAddress);
      setValid(true);
    }
  }, [currentAddress]);

  useEffect(() => {
    if (addressList.length > 0) {
      setHasData(true);
    }
  }, [addressList]);

  const handleUpdateAddressList = async (id?: number) => {
    const res = await fetchCustomerAddress();
    if (res.code === 200) {
      const result =
        res.data.list?.map((item) => {
          const rules = getAddressRules(item, []);
          const addressItem = item as Address;
          addressItem.checked = !rules;
          addressItem.boxChecked = item.is_pobox === 1;
          return addressItem;
        }) || [];

      setAddressList(result);
      getDefaultAddress(id, result);
    }
  };

  useEffect(() => {
    if (actionType !== AddressActionType.DEFAULT) {
      SDAddressEditPageView();
    }
  }, [actionType]);

  /**
   * @TrackType sensorsdata
   * @EventType MyAddressPageBtn_Click
   * @EventDesc 我的地址页按钮点击
   * @EventParams {
   *  btn_name: 按钮名称,
   *  entrance_payment_scene	进入支付页场景
   * }
   * @Tapd 1008875
   */
  const SDMyAddressPageBtnClick = (btn_name: string) => {
    try {
      const eventData = {
        eventName: 'MyAddressPageBtn_Click',
        properties: {
          btn_name,
          address_type: 'Shipping Address',
          entrance_payment_scene: entrancePaymentScene,
        },
      };
      trackEvent(eventData, [ProviderType.SENSORS]);
    } catch (e) {
      logger.log(e);
    }
  };

  /**
   * @TrackType sensorsdata
   * @EventType - PlaceOrderPageAddress_Result
   * @EventDesc - 地址接口加载结果
   * @EventParams {
   *  payment_view_uuid: payment_view_uuid
   *  is_have_address: is_available_coupon
   *  entrance_payment_scene: entrance_payment_scene
   * }
   * @Tapd 1010391
   */
  const SDPlaceOrderPageAddressResult = (is_have_address: boolean) => {
    try {
      const sdEventName = 'PlaceOrderPageAddress_Result';
      const sdEventParams = {
        payment_view_uuid: paymentUuid,
        entrance_payment_scene: entrancePaymentScene,
        is_have_address,
      };
      trackEvent(
        {
          eventName: sdEventName,
          properties: sdEventParams,
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.log(e);
    }
  };

  /**
   * @TrackType sensorsdata
   * @EventType AddressEditPage_View
   * @EventDesc 地址编辑页页面浏览
   * @EventParams {
   *  key: desc,
   * }
   * @Tapd 1008875
   */
  const SDAddressEditPageView = () => {
    if (!entrancePaymentScene) return;
    const sdEventName = 'AddressEditPage_View';
    const sdEventParams = {
      address_type: 'Shipping Address',
      entrance_payment_scene: entrancePaymentScene,
      refer_page_name,
      refer_url_path,
    };
    trackEvent(
      {
        eventName: sdEventName,
        properties: sdEventParams,
      },
      [ProviderType.SENSORS],
    );
  };

  /**
   * @TrackType sensorsdata
   * @EventType AddressEditPageBtn_Click
   * @EventDesc 地址编辑页按钮点击
   * @EventParams {
   *  btn_name: 按钮名称,
   * }
   * @Tapd 1008875
   */
  const SDAddressEditPageBtnClick = (btn_name: string, is_save_success = false) => {
    if (!entrancePaymentScene) return;
    const sdEventName = 'AddressEditPageBtn_Click';
    const sdEventParams = {
      btn_name,
      address_type: 'Shipping Address',
      is_save_success,
      entrance_payment_scene: entrancePaymentScene,
    };
    trackEvent(
      {
        eventName: sdEventName,
        properties: sdEventParams,
      },
      [ProviderType.SENSORS],
    );
  };

  return (
    <div className="relative ">
      {!isMobile && hasData && actionType === AddressActionType.DEFAULT && (
        <div className="mb-[16px] flex justify-between items-center pd-[0_16px]">
          <h3 className="text-[18px] font-bb">{t('shippingAddress')}</h3>
          <div
            className="text-primary-purple underline cursor-pointer text-[14px]"
            onClick={() => {
              SDMyAddressPageBtnClick('Add New Address');
              addNewAddress();
            }}
          >
            + {t('addNewAddress')}
          </div>
        </div>
      )}

      {isMobile && !hasData && (
        <div
          className={`bg-white px-[16px] py-[20px] rounded-[10px] flex flex-col justify-between items-center ${
            !valid ? 'border-1 border-[#BC1B1B]' : ''
          }`}
          onClick={() => {
            setOpenAddNewAddress(true);
          }}
        >
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center justify-start flex-1">
              <Image src="/payment/address_icon.png" alt="add-new-address" width={30} height={30} />
              <h3 className="text-[18px] font-bb ml-10">{t('addNewAddress')}</h3>
            </div>

            <RightArrowOutlined className="text-[20px]" />
          </div>

          {!valid && (
            <div className="mt-[35px] text-[#BC1B1B] text-12 text-left w-full">
              {t('addressRequired')}
            </div>
          )}
        </div>
      )}

      {currentAddress && actionType === AddressActionType.DEFAULT && hasData && (
        <AddressPreview
          address={currentAddress}
          addressList={addressList}
          onChooseAddress={onChooseAddress}
          onEditAddress={editAddress}
          isMobile={isMobile}
          valid={valid}
          onOpenMobileChooseAddress={() => setChooseAddressShow(true)}
        />
      )}

      {!isMobile && actionType !== AddressActionType.DEFAULT && (
        <>
          <h3 className="font-bb text-[18px] pl-16 mb-[24px] leading-[1]">
            {t('shippingAddress')}
          </h3>
          <AddressForm
            data={addressFormData}
            close={handleCancel}
            onSubmit={handleOnSubmit}
            type={actionType}
            showCancel={showCancel}
            saveBtnSxPc={{
              maxWidth: '50%',
              borderRadius: '10px',
            }}
            loading={loading}
          />
        </>
      )}

      {isMobile && (
        <Popup
          open={openAddNewAddress}
          onClose={() => {
            setOpenAddNewAddress(false);
          }}
          position="right"
          height="100%"
          width="100%"
          sx={{
            '& .MuiDrawer-paper': {
              borderRadius: '0',
              width: '100%',
              backgroundColor: '#f5f6f7',
            },
            '& .MuiBox-root': {
              padding: '0',
            },
          }}
        >
          <MobileNav
            className="!absolute top-0 left-0 w-full z-20 bg-[#f5f6f7]"
            titleClassName="text-center w-full text-[18px] font-bb"
            title="Shipping Address"
            goBack={() => {
              setOpenAddNewAddress(false);
            }}
          />

          <div className="pt-[50px]">
            <AddressForm
              data={addressFormData}
              type={actionType as 'ADD' | 'EDIT'}
              onSubmit={handleOnSubmit}
              close={() => {
                SDAddressEditPageBtnClick('Cancel', false);
                setOpenAddNewAddress(false);
              }}
              loading={loading}
              isNeedPagePadding
            />
          </div>
        </Popup>
      )}

      {isMobile && (
        <ChooseAddress
          open={chooseAddressShow}
          onClose={() => setChooseAddressShow(false)}
          addressList={addressList}
          countryList={countryList}
          onChooseAddress={onChooseAddress}
          onUpdateAddressList={handleUpdateAddressList}
          onTrackEvent={SDMyAddressPageBtnClick}
          onEditTrackEvent={SDAddressEditPageBtnClick}
        />
      )}
    </div>
  );
}
